<dialog
  #leaveConfirmationDialog
  qai-dialog
  class="leave-confirmation-dialog"
  [heading]="'simulationBuilder.LEAVE_CONFIRMATION_HEADING' | transloco"
  [description]="'simulationBuilder.LEAVE_CONFIRMATION_DESCRIPTION' | transloco"
  [showClose]="false"
>
  <div class="leave-confirmation-actions">
    <button
      qai-button
      kind="secondary"
      size="medium"
      [disabled]="networkRequestInProgress()"
      (click)="handleClose()"
    >
      {{ 'simulationBuilder.BUTTON_CANCEL' | transloco }}
    </button>
    <button
      qai-button
      kind="destructive"
      size="medium"
      [disabled]="networkRequestInProgress()"
      (click)="handleLeave()"
    >
      {{ 'simulationBuilder.LEAVE_CONFIRMATION_LEAVE_BUTTON' | transloco }}
    </button>
  </div>
</dialog>
